export default __webpack_public_path__ + "3d053df2ed3727f4597b1393264d43f0.jpg";